var $2wEZH$reactariautils = require("@react-aria/utils");
var $2wEZH$react = require("react");
var $2wEZH$reactariainteractions = require("@react-aria/interactions");
var $2wEZH$reactariatextfield = require("@react-aria/textfield");
var $2wEZH$reactariai18n = require("@react-aria/i18n");
var $2wEZH$reactariaspinbutton = require("@react-aria/spinbutton");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useNumberField", () => $fa863e9b015ae839$export$23f548e970bdf099);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

var $4932e21065cdc2cd$exports = {};
var $15c26e9e75543508$exports = {};
$15c26e9e75543508$exports = {
  "decrease": args => "\u062E\u0641\u0636 ".concat(args.fieldLabel),
  "increase": args => "\u0632\u064A\u0627\u062F\u0629 ".concat(args.fieldLabel),
  "numberField": "\u062D\u0642\u0644 \u0631\u0642\u0645\u064A"
};
var $2d346802965e5c25$exports = {};
$2d346802965e5c25$exports = {
  "decrease": args => "\u041D\u0430\u043C\u0430\u043B\u044F\u0432\u0430\u043D\u0435 ".concat(args.fieldLabel),
  "increase": args => "\u0423\u0441\u0438\u043B\u0432\u0430\u043D\u0435 ".concat(args.fieldLabel),
  "numberField": "\u041D\u043E\u043C\u0435\u0440 \u043D\u0430 \u043F\u043E\u043B\u0435\u0442\u043E"
};
var $09893e85abdd2974$exports = {};
$09893e85abdd2974$exports = {
  "decrease": args => "Sn\xED\u017Eit ".concat(args.fieldLabel),
  "increase": args => "Zv\xFD\u0161it ".concat(args.fieldLabel),
  "numberField": "\u010C\xEDseln\xE9 pole"
};
var $413bf45f477fb4e1$exports = {};
$413bf45f477fb4e1$exports = {
  "decrease": args => "Reducer ".concat(args.fieldLabel),
  "increase": args => "\xD8g ".concat(args.fieldLabel),
  "numberField": "Talfelt"
};
var $2727845e2efab680$exports = {};
$2727845e2efab680$exports = {
  "decrease": args => "".concat(args.fieldLabel, " verringern"),
  "increase": args => "".concat(args.fieldLabel, " erh\xF6hen"),
  "numberField": "Nummernfeld"
};
var $11030a3afacdbc2e$exports = {};
$11030a3afacdbc2e$exports = {
  "decrease": args => "\u039C\u03B5\u03AF\u03C9\u03C3\u03B7 ".concat(args.fieldLabel),
  "increase": args => "\u0391\u03CD\u03BE\u03B7\u03C3\u03B7 ".concat(args.fieldLabel),
  "numberField": "\u03A0\u03B5\u03B4\u03AF\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03BF\u03CD"
};
var $1e48617299cb10e8$exports = {};
$1e48617299cb10e8$exports = {
  "decrease": args => "Decrease ".concat(args.fieldLabel),
  "increase": args => "Increase ".concat(args.fieldLabel),
  "numberField": "Number field"
};
var $335176f389a02847$exports = {};
$335176f389a02847$exports = {
  "decrease": args => "Reducir ".concat(args.fieldLabel),
  "increase": args => "Aumentar ".concat(args.fieldLabel),
  "numberField": "Campo de n\xFAmero"
};
var $b08e7fdc34a812f3$exports = {};
$b08e7fdc34a812f3$exports = {
  "decrease": args => "V\xE4henda ".concat(args.fieldLabel),
  "increase": args => "Suurenda ".concat(args.fieldLabel),
  "numberField": "Numbri v\xE4li"
};
var $ce4c5a1eb7e6fc96$exports = {};
$ce4c5a1eb7e6fc96$exports = {
  "decrease": args => "V\xE4henn\xE4 ".concat(args.fieldLabel),
  "increase": args => "Lis\xE4\xE4 ".concat(args.fieldLabel),
  "numberField": "Numerokentt\xE4"
};
var $341f988ce23c559c$exports = {};
$341f988ce23c559c$exports = {
  "decrease": args => "Diminuer ".concat(args.fieldLabel),
  "increase": args => "Augmenter ".concat(args.fieldLabel),
  "numberField": "Champ de nombre"
};
var $950fd1a1d57d2f86$exports = {};
$950fd1a1d57d2f86$exports = {
  "decrease": args => "\u05D4\u05E7\u05D8\u05DF ".concat(args.fieldLabel),
  "increase": args => "\u05D4\u05D2\u05D3\u05DC ".concat(args.fieldLabel),
  "numberField": "\u05E9\u05D3\u05D4 \u05DE\u05E1\u05E4\u05E8"
};
var $7b949fa64cf10a07$exports = {};
$7b949fa64cf10a07$exports = {
  "decrease": args => "Smanji ".concat(args.fieldLabel),
  "increase": args => "Pove\u0107aj ".concat(args.fieldLabel),
  "numberField": "Polje broja"
};
var $a945ff6d5cb9cf90$exports = {};
$a945ff6d5cb9cf90$exports = {
  "decrease": args => "".concat(args.fieldLabel, " cs\xF6kkent\xE9se"),
  "increase": args => "".concat(args.fieldLabel, " n\xF6vel\xE9se"),
  "numberField": "Sz\xE1mmez\u0151"
};
var $f3393075c1f078d7$exports = {};
$f3393075c1f078d7$exports = {
  "decrease": args => "Riduci ".concat(args.fieldLabel),
  "increase": args => "Aumenta ".concat(args.fieldLabel),
  "numberField": "Campo numero"
};
var $a12655e072ef354d$exports = {};
$a12655e072ef354d$exports = {
  "decrease": args => "".concat(args.fieldLabel, "\u3092\u7E2E\u5C0F"),
  "increase": args => "".concat(args.fieldLabel, "\u3092\u62E1\u5927"),
  "numberField": "\u6570\u5024\u30D5\u30A3\u30FC\u30EB\u30C9"
};
var $880dbee0519c1bad$exports = {};
$880dbee0519c1bad$exports = {
  "decrease": args => "".concat(args.fieldLabel, " \uAC10\uC18C"),
  "increase": args => "".concat(args.fieldLabel, " \uC99D\uAC00"),
  "numberField": "\uBC88\uD638 \uD544\uB4DC"
};
var $d4a9630b079105aa$exports = {};
$d4a9630b079105aa$exports = {
  "decrease": args => "Suma\u017Einti ".concat(args.fieldLabel),
  "increase": args => "Padidinti ".concat(args.fieldLabel),
  "numberField": "Numerio laukas"
};
var $e358cd3315986eb7$exports = {};
$e358cd3315986eb7$exports = {
  "decrease": args => "Samazin\u0101\u0161ana ".concat(args.fieldLabel),
  "increase": args => "Palielin\u0101\u0161ana ".concat(args.fieldLabel),
  "numberField": "Skait\u013Cu lauks"
};
var $a8d0ee8ec28363c7$exports = {};
$a8d0ee8ec28363c7$exports = {
  "decrease": args => "Reduser ".concat(args.fieldLabel),
  "increase": args => "\xD8k ".concat(args.fieldLabel),
  "numberField": "Tallfelt"
};
var $0073957e0c754983$exports = {};
$0073957e0c754983$exports = {
  "decrease": args => "".concat(args.fieldLabel, " verlagen"),
  "increase": args => "".concat(args.fieldLabel, " verhogen"),
  "numberField": "Getalveld"
};
var $51626cc4fccef54e$exports = {};
$51626cc4fccef54e$exports = {
  "decrease": args => "Zmniejsz ".concat(args.fieldLabel),
  "increase": args => "Zwi\u0119ksz ".concat(args.fieldLabel),
  "numberField": "Pole numeru"
};
var $60b1cee412b56d27$exports = {};
$60b1cee412b56d27$exports = {
  "decrease": args => "Diminuir ".concat(args.fieldLabel),
  "increase": args => "Aumentar ".concat(args.fieldLabel),
  "numberField": "Campo de n\xFAmero"
};
var $df9c7cc4e8072a0f$exports = {};
$df9c7cc4e8072a0f$exports = {
  "decrease": args => "Diminuir ".concat(args.fieldLabel),
  "increase": args => "Aumentar ".concat(args.fieldLabel),
  "numberField": "Campo num\xE9rico"
};
var $aea54857f9df076d$exports = {};
$aea54857f9df076d$exports = {
  "decrease": args => "Sc\u0103dere ".concat(args.fieldLabel),
  "increase": args => "Cre\u0219tere ".concat(args.fieldLabel),
  "numberField": "C\xE2mp numeric"
};
var $8337ebc47a7e61a3$exports = {};
$8337ebc47a7e61a3$exports = {
  "decrease": args => "\u0423\u043C\u0435\u043D\u044C\u0448\u0435\u043D\u0438\u0435 ".concat(args.fieldLabel),
  "increase": args => "\u0423\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u0435 ".concat(args.fieldLabel),
  "numberField": "\u0427\u0438\u0441\u043B\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435"
};
var $4703837f8f4224f8$exports = {};
$4703837f8f4224f8$exports = {
  "decrease": args => "Zn\xED\u017Ei\u0165 ".concat(args.fieldLabel),
  "increase": args => "Zv\xFD\u0161i\u0165 ".concat(args.fieldLabel),
  "numberField": "\u010C\xEDseln\xE9 pole"
};
var $2b9c8b37ab5bbcca$exports = {};
$2b9c8b37ab5bbcca$exports = {
  "decrease": args => "Upadati ".concat(args.fieldLabel),
  "increase": args => "Pove\u010Dajte ".concat(args.fieldLabel),
  "numberField": "\u0160tevil\u010Dno polje"
};
var $2c78665a3b81ed56$exports = {};
$2c78665a3b81ed56$exports = {
  "decrease": args => "Decrease ".concat(args.fieldLabel),
  "increase": args => "Increase ".concat(args.fieldLabel),
  "numberField": "Number field"
};
var $8da5dab2105c0d01$exports = {};
$8da5dab2105c0d01$exports = {
  "decrease": args => "Minska ".concat(args.fieldLabel),
  "increase": args => "\xD6ka ".concat(args.fieldLabel),
  "numberField": "Nummerf\xE4lt"
};
var $73a2418cb50e8fda$exports = {};
$73a2418cb50e8fda$exports = {
  "decrease": args => "".concat(args.fieldLabel, " azalt"),
  "increase": args => "".concat(args.fieldLabel, " artt\u0131r"),
  "numberField": "Say\u0131 alan\u0131"
};
var $9c85d1989bb8c41d$exports = {};
$9c85d1989bb8c41d$exports = {
  "decrease": args => "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438 ".concat(args.fieldLabel),
  "increase": args => "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 ".concat(args.fieldLabel),
  "numberField": "\u041F\u043E\u043B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430"
};
var $a7db09d81aa41beb$exports = {};
$a7db09d81aa41beb$exports = {
  "decrease": args => "\u964D\u4F4E ".concat(args.fieldLabel),
  "increase": args => "\u63D0\u9AD8 ".concat(args.fieldLabel),
  "numberField": "\u6570\u5B57\u5B57\u6BB5"
};
var $edd6ee4675b7a1cd$exports = {};
$edd6ee4675b7a1cd$exports = {
  "decrease": args => "\u7E2E\u5C0F ".concat(args.fieldLabel),
  "increase": args => "\u653E\u5927 ".concat(args.fieldLabel),
  "numberField": "\u6578\u5B57\u6B04\u4F4D"
};
$4932e21065cdc2cd$exports = {
  "ar-AE": $15c26e9e75543508$exports,
  "bg-BG": $2d346802965e5c25$exports,
  "cs-CZ": $09893e85abdd2974$exports,
  "da-DK": $413bf45f477fb4e1$exports,
  "de-DE": $2727845e2efab680$exports,
  "el-GR": $11030a3afacdbc2e$exports,
  "en-US": $1e48617299cb10e8$exports,
  "es-ES": $335176f389a02847$exports,
  "et-EE": $b08e7fdc34a812f3$exports,
  "fi-FI": $ce4c5a1eb7e6fc96$exports,
  "fr-FR": $341f988ce23c559c$exports,
  "he-IL": $950fd1a1d57d2f86$exports,
  "hr-HR": $7b949fa64cf10a07$exports,
  "hu-HU": $a945ff6d5cb9cf90$exports,
  "it-IT": $f3393075c1f078d7$exports,
  "ja-JP": $a12655e072ef354d$exports,
  "ko-KR": $880dbee0519c1bad$exports,
  "lt-LT": $d4a9630b079105aa$exports,
  "lv-LV": $e358cd3315986eb7$exports,
  "nb-NO": $a8d0ee8ec28363c7$exports,
  "nl-NL": $0073957e0c754983$exports,
  "pl-PL": $51626cc4fccef54e$exports,
  "pt-BR": $60b1cee412b56d27$exports,
  "pt-PT": $df9c7cc4e8072a0f$exports,
  "ro-RO": $aea54857f9df076d$exports,
  "ru-RU": $8337ebc47a7e61a3$exports,
  "sk-SK": $4703837f8f4224f8$exports,
  "sl-SI": $2b9c8b37ab5bbcca$exports,
  "sr-SP": $2c78665a3b81ed56$exports,
  "sv-SE": $8da5dab2105c0d01$exports,
  "tr-TR": $73a2418cb50e8fda$exports,
  "uk-UA": $9c85d1989bb8c41d$exports,
  "zh-CN": $a7db09d81aa41beb$exports,
  "zh-TW": $edd6ee4675b7a1cd$exports
};
function $fa863e9b015ae839$export$23f548e970bdf099(props, state, inputRef) {
  let {
    id: id,
    decrementAriaLabel: decrementAriaLabel,
    incrementAriaLabel: incrementAriaLabel,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    minValue: minValue,
    maxValue: maxValue,
    autoFocus: autoFocus,
    validationState: validationState,
    isInvalid: isInvalid,
    label: label,
    formatOptions: formatOptions,
    onBlur = () => {},
    onFocus: onFocus,
    onFocusChange: onFocusChange,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    description: description,
    errorMessage: errorMessage,
    ...otherProps
  } = props;
  let {
    increment: increment,
    incrementToMax: incrementToMax,
    decrement: decrement,
    decrementToMin: decrementToMin,
    numberValue: numberValue,
    inputValue: inputValue,
    commit: commit
  } = state;
  const stringFormatter = (0, $2wEZH$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($4932e21065cdc2cd$exports)));
  let inputId = (0, $2wEZH$reactariautils.useId)(id);
  let {
    focusProps: focusProps
  } = (0, $2wEZH$reactariainteractions.useFocus)({
    onBlur: () => {
      // Set input value to normalized valid value
      commit();
    }
  });
  let numberFormatter = (0, $2wEZH$reactariai18n.useNumberFormatter)(formatOptions);
  let intlOptions = (0, $2wEZH$react.useMemo)(() => numberFormatter.resolvedOptions(), [numberFormatter]);
  // Replace negative textValue formatted using currencySign: 'accounting'
  // with a textValue that can be announced using a minus sign.
  let textValueFormatter = (0, $2wEZH$reactariai18n.useNumberFormatter)({
    ...formatOptions,
    currencySign: undefined
  });
  let textValue = (0, $2wEZH$react.useMemo)(() => isNaN(numberValue) ? "" : textValueFormatter.format(numberValue), [textValueFormatter, numberValue]);
  let {
    spinButtonProps: spinButtonProps,
    incrementButtonProps: incButtonProps,
    decrementButtonProps: decButtonProps
  } = (0, $2wEZH$reactariaspinbutton.useSpinButton)({
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    maxValue: maxValue,
    minValue: minValue,
    onIncrement: increment,
    onIncrementToMax: incrementToMax,
    onDecrement: decrement,
    onDecrementToMin: decrementToMin,
    value: numberValue,
    textValue: textValue
  });
  let [focusWithin, setFocusWithin] = (0, $2wEZH$react.useState)(false);
  let {
    focusWithinProps: focusWithinProps
  } = (0, $2wEZH$reactariainteractions.useFocusWithin)({
    isDisabled: isDisabled,
    onFocusWithinChange: setFocusWithin
  });
  let onWheel = (0, $2wEZH$react.useCallback)(e => {
    // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
    // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
    // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
    // especially if the user is scrolling near 45deg
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    if (e.deltaY > 0) increment();else if (e.deltaY < 0) decrement();
  }, [decrement, increment]);
  // If the input isn't supposed to receive input, disable scrolling.
  let scrollingDisabled = isDisabled || isReadOnly || !focusWithin;
  (0, $2wEZH$reactariainteractions.useScrollWheel)({
    onScroll: onWheel,
    isDisabled: scrollingDisabled
  }, inputRef);
  // The inputMode attribute influences the software keyboard that is shown on touch devices.
  // Browsers and operating systems are quite inconsistent about what keys are available, however.
  // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
  // and based on testing on various devices to determine what keys are available in each inputMode.
  let hasDecimals = intlOptions.maximumFractionDigits > 0;
  let hasNegative = isNaN(state.minValue) || state.minValue < 0;
  let inputMode = "numeric";
  if ((0, $2wEZH$reactariautils.isIPhone)()) {
    // iPhone doesn't have a minus sign in either numeric or decimal.
    // Note this is only for iPhone, not iPad, which always has both
    // minus and decimal in numeric.
    if (hasNegative) inputMode = "text";else if (hasDecimals) inputMode = "decimal";
  } else if ((0, $2wEZH$reactariautils.isAndroid)()) {
    // Android numeric has both a decimal point and minus key.
    // decimal does not have a minus key.
    if (hasNegative) inputMode = "numeric";else if (hasDecimals) inputMode = "decimal";
  }
  let onChange = value => {
    if (state.validate(value)) state.setInputValue(value);
  };
  let domProps = (0, $2wEZH$reactariautils.filterDOMProps)(props);
  let {
    labelProps: labelProps,
    inputProps: textFieldProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $2wEZH$reactariatextfield.useFormattedTextField)({
    ...otherProps,
    ...domProps,
    name: undefined,
    label: label,
    autoFocus: autoFocus,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    validationState: validationState,
    isInvalid: isInvalid,
    value: inputValue,
    defaultValue: undefined,
    autoComplete: "off",
    "aria-label": props["aria-label"] || null,
    "aria-labelledby": props["aria-labelledby"] || null,
    id: inputId,
    type: "text",
    inputMode: inputMode,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    onFocusChange: onFocusChange,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    description: description,
    errorMessage: errorMessage
  }, state, inputRef);
  (0, $2wEZH$reactariautils.useFormReset)(inputRef, state.numberValue, state.setNumberValue);
  let inputProps = (0, $2wEZH$reactariautils.mergeProps)(spinButtonProps, focusProps, textFieldProps, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": !(0, $2wEZH$reactariautils.isIOS)() ? stringFormatter.format("numberField") : null,
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  let onButtonPressStart = e => {
    // If focus is already on the input, keep it there so we don't hide the
    // software keyboard when tapping the increment/decrement buttons.
    if (document.activeElement === inputRef.current) return;
    // Otherwise, when using a mouse, move focus to the input.
    // On touch, or with a screen reader, focus the button so that the software
    // keyboard does not appear and the screen reader cursor is not moved off the button.
    if (e.pointerType === "mouse") inputRef.current.focus();else e.target.focus();
  };
  // Determine the label for the increment and decrement buttons. There are 4 cases:
  //
  // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
  // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
  // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
  // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
  //
  // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
  // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
  // the order or add additional words around the label if needed.
  let fieldLabel = props["aria-label"] || (typeof props.label === "string" ? props.label : "");
  let ariaLabelledby;
  if (!fieldLabel) ariaLabelledby = props.label != null ? labelProps.id : props["aria-labelledby"];
  let incrementId = (0, $2wEZH$reactariautils.useId)();
  let decrementId = (0, $2wEZH$reactariautils.useId)();
  let incrementButtonProps = (0, $2wEZH$reactariautils.mergeProps)(incButtonProps, {
    "aria-label": incrementAriaLabel || stringFormatter.format("increase", {
      fieldLabel: fieldLabel
    }).trim(),
    id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
    "aria-labelledby": ariaLabelledby && !incrementAriaLabel ? "".concat(incrementId, " ").concat(ariaLabelledby) : null,
    "aria-controls": inputId,
    excludeFromTabOrder: true,
    preventFocusOnPress: true,
    allowFocusWhenDisabled: true,
    isDisabled: !state.canIncrement,
    onPressStart: onButtonPressStart
  });
  let decrementButtonProps = (0, $2wEZH$reactariautils.mergeProps)(decButtonProps, {
    "aria-label": decrementAriaLabel || stringFormatter.format("decrease", {
      fieldLabel: fieldLabel
    }).trim(),
    id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
    "aria-labelledby": ariaLabelledby && !decrementAriaLabel ? "".concat(decrementId, " ").concat(ariaLabelledby) : null,
    "aria-controls": inputId,
    excludeFromTabOrder: true,
    preventFocusOnPress: true,
    allowFocusWhenDisabled: true,
    isDisabled: !state.canDecrement,
    onPressStart: onButtonPressStart
  });
  return {
    groupProps: {
      role: "group",
      "aria-disabled": isDisabled,
      "aria-invalid": validationState === "invalid" ? "true" : undefined,
      ...focusWithinProps
    },
    labelProps: labelProps,
    inputProps: inputProps,
    incrementButtonProps: incrementButtonProps,
    decrementButtonProps: decrementButtonProps,
    errorMessageProps: errorMessageProps,
    descriptionProps: descriptionProps
  };
}